module.exports = __webpack_public_path__ + "static/img/result-head.4ad8f9f1.jpg";